import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Slider } from '../components/Slider';

function AlumniRegistrationForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [yearOfPassing, setYearOfPassing] = useState("");
    const [emailError, setEmailError] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState("");
    const [occupation, setOccupation] = useState("");
    const [address, setAddress] = useState("");
    const [gender, setGender] = useState("");
    const [afterDiploma, setAfterDiploma] = useState("");
    const handleSubmit = (event) => {
        event.preventDefault();
    };



    return (
        <>
            <Slider />
            <div className="header-parent sticky top-0">
                {/* Header can be included here if needed */}
            </div>
            <br />
            <div className="   max-w-[80%] mx-auto p-4 " method="post" action="https://gpsakoli.ac.in/public/api/connection?action=insertAlumniDetails" onSubmit={handleSubmit}>
                <h1 className="heading text-center">Alumni <span className="heading-red">Association</span></h1>
                <br></br>
                <h1 className="heading heading-top-left-line">The Alumni Association was established for the year 2022-23</h1>
                <b>Aims and Objectives</b>
  <ul>
    <li>To encourage students and Ex-students of Government polytechnic and belonging to economically weaker section to seek a career in higher education and services.</li>
    <li>To provide assistance, guidance, prepare themselves for such examinations and also to develop in them personal qualities and attitude</li>
    <li>To guide and advice students in finding employment, self employment in training in college and industries</li>
    <li>To promote programmes on personality development, interview techniques, leadership development, education in health, science, yoga, culture, literature, sports and similar other matters.</li>
    <li>To encourage research activities related to industries</li>
    <li>To promote cultural programmes to educate them in different cultural back ground.</li>
    <li>To promote programmes, competitions for development of art, science, culture, literature and value education.</li>
    <li>To support Government and Semi-government programmes on education, research, technology and culture.</li>
    <li>To do all kinds of acts which are just proper and necessary for fulfilling aims and objectives of the   
     organization.
</li>
  
  </ul>
  <h1 className="heading heading-top-left-line">Alumni Committee</h1>

			
			<table border="1px">
				<thead>
					<tr>
						<td>Sr. No.</td>
						<td>Name of Members</td>
						<td>Designation</td>
                        <td>Contact No.</td>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>1</td>
						<td>Prof .S.P. Lambhade</td>
						<td>Principal</td>
                        <td>9423433588</td>
					</tr>
					<tr>
						<td>2</td>
						<td>Dr. B.R. Ambade</td>
						<td>Chairman</td>
                        <td>7507939137</td>
					</tr>
					<tr>
						<td>3</td>
						<td>Prof. L.P. Sakharwade</td>
						<td>Secretary</td>
                        <td>9923255355</td>
					</tr>
					<tr>
						<td>4</td>
						<td>Shri.  Fazil Khan</td>
						<td>Joint Secretary</td>
                        <td>9422116826</td>
					</tr>
					<tr>
						<td>5</td>
						<td>Shri. Lokesh Tembhare</td>
						<td>Treasurer</td>
                        <td>9403073060</td>
					</tr>
                    <tr>
						<td>6</td>
						<td>Shri. Prasanna Gupta</td>
						<td>Committee Member</td>
                        <td>7020470827</td>
					</tr>
                    <tr>
						<td>7</td>
						<td>Shri. Ravi Makode</td>
						<td>Committee Member</td>
                        <td>9422133158</td>
					</tr>
                    <tr>
						<td>8</td>
						<td>Shri. Kamran Khan</td>
						<td>Committee Member</td>
                        <td>9823838463</td>
					</tr>
                    <tr>
						<td>9</td>
						<td>Shri. Rajesh Yele</td>
						<td>Committee Member</td>
                        <td>9765863757</td>
					</tr>
                    <tr>
						<td>10</td>
						<td>Shri. Sandip Mahakalkar</td>
						<td>Committee Member</td>
                        <td>9923401819</td>
					</tr>
                    <tr>
						<td>11</td>
						<td>Shri. Vinod  Gangapari</td>
						<td>Committee Member</td>
                        <td>9823505823</td>
					</tr>
				</tbody>
			</table>

            </div>
        </>
    );
}

export default AlumniRegistrationForm;
